export default __webpack_public_path__ + "static/media/040-chevron-right.62678613.svg";